<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { Spinner } from '@client/components/spinner';

  import { DIRECTORY_FIELDS_SYSTEMS } from '@client/enums/directory-fields';

  export let data = {};
  export let selectedSyncData = {};

  const getSyncedData = (userConfig = {}) => {
    const result = {};

    try {
      for (const [key, dataLabel] of Object.entries(DIRECTORY_FIELDS_SYSTEMS)) {
        // skip customdir and params as they are not synced data
        if (key === 'customdir' || key === 'params') {
          continue;
        }

        const data = userConfig?.[key];

        if (data) {
          result[key] = {
            data,
            dataLabel
          };
        }
      }
    } catch (err) {
      console.log(err);
    }

    return result;
  };

  const showSyncedDataModal = (config) => {
    selectedSyncData = config;
  };
</script>

<div class="pt-3">
  <div class="fields">
    <h2 class="heading">{$format('label.DIRECTORY_AND_PLATFORM_INTEGRATIONS')}</h2>
    {#await getSyncedData(data)}
      <div class="section-loading">
        <Spinner show inline />
      </div>
    {:then syncedData}
      <p class="pb-3">
        {@html $format('label.DESCRIPTION.DIRECTORY_AND_PLATFORM_INTEGRATIONS')}
      </p>
      <div class="content">
        <div class="sync-entries">
          {#if Object.entries(syncedData).length}
            <div class="sync-header">
              <div class="sync-name"><b>{$format('label.NAME')}</b></div>
            </div>
            {#each Object.entries(syncedData) as [key, config]}
              <div class="sync-entry">
                <div class="sync-name">
                  <div>
                    <div>{config.dataLabel}</div>
                  </div>
                </div>
                <div class="sync-actions">
                  <Button color="secondary" size="sm" on:click={() => showSyncedDataModal(config)}>View</Button>
                </div>
              </div>
            {/each}
          {:else}
            <div class="sync-entries">
              <div>{$format('label.MESSAGE.NO_DIRECTORY_DATA')}</div>
            </div>
          {/if}
        </div>
      </div>
    {:catch error}
      <div class="content">
        <div class="sync-entries">
          <div class="error">{error.message}</div>
        </div>
      </div>
    {/await}
  </div>
</div>

<style lang="scss" src="./directory-settings.scss"></style>
